import React from "react";
import PerformaOne from "./Edits/PerfomaOne";
import ClinicalFeature from "./Edits/ClinicalFeature";
import UpdatePatient from "./Edits/UpdatePatient";
import Dexa from "./Edits/Dexa";
import Dexa1 from "./Edits/Dexa1";
import Dexa3 from "./Edits/Dexa3";
import DisorderAndTreatment from "./Edits/DisorderAndTreatment";
import Investigation from "./Edits/Investigation";
import Scans from "./Edits/Scans";
import Xray from "./Edits/Xray";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Container,
} from "reactstrap";
import classnames from "classnames";
import Hrpqct from "./Edits/Hrpqct";

const navStyle = {
  fontSize: 18,
  padding: 0,
  marginBottom: 3,
  border: 0,
};

class EditPatient extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
    };
  }
  componentDidMount() {
    // const reloadCount = sessionStorage.getItem("reloadCount");
    // if (reloadCount < 1) {
    //   sessionStorage.setItem("reloadCount", String(reloadCount + 1));
    //   console.log(sessionStorage.getItem("reloadCount"))
    //   window.location.reload();
    // } else {
    //   sessionStorage.removeItem("reloadCount");
    // }
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    console.log("props"+JSON.stringify(this.state ))
    return (
      <Container style={{ maxWidth: 1000 }}>
        <h4>Note: Please click save before swiching tabs</h4>
        <Row>
          <Col xs="12" sm="12" md="2">
            <Nav tabs vertical pills>
              <br />
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggle("1");
                  }}
                >
                  Pateint Details
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "2",
                  })}
                  onClick={() => {
                    this.toggle("2");
                  }}
                >
                  Performa One
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "3",
                  })}
                  onClick={() => {
                    this.toggle("3");
                  }}
                >
                  Clinical Feature
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "4",
                  })}
                  onClick={() => {
                    this.toggle("4");
                  }}
                >
                  Investigation
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "5",
                  })}
                  onClick={() => {
                    this.toggle("5");
                  }}
                >
                  Dexa
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "6",
                  })}
                  onClick={() => {
                    this.toggle("6");
                  }}
                >
                  Dexa after 1 year
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "7",
                  })}
                  onClick={() => {
                    this.toggle("7");
                  }}
                >
                  Dexa after 3 years
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "8",
                  })}
                  onClick={() => {
                    this.toggle("8");
                  }}
                >
                  Scans
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "9",
                  })}
                  onClick={() => {
                    this.toggle("9");
                  }}
                >
                  X-ray
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "10",
                  })}
                  onClick={() => {
                    this.toggle("10");
                  }}
                >
                  Disorder And Treatment
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={navStyle}
                  className={classnames({
                    active: this.state.activeTab === "11",
                  })}
                  onClick={() => {
                    this.toggle("11");
                  }}
                >
                  HR -pQCT
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
          <Col xs="12" sm="12" md="10">
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <UpdatePatient id={this.props.match.params.id} />
              </TabPane>
              <TabPane tabId="2">
                <PerformaOne id={this.props.match.params.id} />
              </TabPane>
              <TabPane tabId="3">
                <ClinicalFeature id={this.props.match.params.id} />
              </TabPane>
              <TabPane tabId="4">
                <Investigation id={this.props.match.params.id} />
              </TabPane>
              <TabPane tabId="5">
                <Dexa id={this.props.match.params.id} />
              </TabPane>
              <TabPane tabId="6">
                <Dexa1 id={this.props.match.params.id} />
              </TabPane>
              <TabPane tabId="7">
                <Dexa3 id={this.props.match.params.id} />
              </TabPane>
              <TabPane tabId="8">
                <Scans id={this.props.match.params.id} />
              </TabPane>
              <TabPane tabId="9">
                <Xray id={this.props.match.params.id} />
              </TabPane>
              <TabPane tabId="10">
                <DisorderAndTreatment id={this.props.match.params.id} />
              </TabPane>
              <TabPane tabId="11">
                <Hrpqct id={this.props.match.params.id} />
              </TabPane>
            </TabContent>
          </Col>
        </Row>
        <hr className="my-2" />
        <p>
          Department of Endocrinology
          <br />
          Postgraduate Institute of Medical Education &amp; Research
          <br />
          Chandigarh, India - 160012
        </p>
        <p className="lead"></p>
      </Container>
    );
  }
}

export default EditPatient;
